import * as classnames from "classnames";

import { Icon, JumpTo, Msg } from "@shared/components";
import Message from "@shared/services/message";

export function SupportedProgrammingLanguagesLink({
  className,
}: {
  className?: string;
}) {
  const rootStyle = classnames(
    "code-supported-programming-languages-link",
    className,
  );
  return (
    <div className={rootStyle}>
      <Msg
        id="challenge.supportedProgrammingLanguages"
        values={{
          a: (chunks: string) => (
            <JumpTo
              to={Message.getMessageByKey(
                "challenge.supportedProgrammingLanguages.url",
              )}
            >
              {chunks}
            </JumpTo>
          ),
          externalLinkIcon: <Icon type="external-link" />,
        }}
      />
    </div>
  );
}
